const React = require("react");
const withState = require("../../../../../utils/withState");
const {account$} = require("../../../../../emitters/account");
const Loading = require("../../../../dumb/Loading");
const {MerchantSelect} = require("../../../../dumb/FormInputs");
const {apiReloginMerchant} = require("../../../../../api/_auth");
const {default: ExitToApp} = require("@material-ui/icons/ExitToApp");
const Ripple = require("../../../../dumb/Ripple");
const UpdateIcon = require("@material-ui/icons/Update");
const BtnTableGlobal = require("../../../../dumb/AdminHelpers/Buttons/components/BtnTableGlobal");

const {
  signOut,
} = account$;

module.exports = withState(() => {
  return (state) => {
    const account = state.account || {};
    const accountsList = account.accountsList || [];
    return (
      <div className="h140 h80@m layoutRow fhaB fvaC">
        <div className="layoutRow fhaS fvaC">
          {state.loadingReconnect ? (
            <>
              <div className="sq50 rlv c0>.CircularProgress">
                <Loading/>
              </div>
              <div className="pl15">Reconnection...</div>
            </>
          ) : null}
        </div>
        {account && (
          <div className="layoutRow aiC">
            <div>
              {accountsList.length > 1
                ? (
                  <MerchantSelect
                    propName="login"
                    propValue="id"
                    items={accountsList}
                    value={account.id}
                    onChange={(name, val) => apiReloginMerchant({id: val})}
                    testId="selectActiveAccount"
                  />
                )
                : (
                  account.login
                )}
            </div>
            {/*<a href="#" className="ml10 tdN ttU" onClick={(e) => {*/}
            {/*  e.preventDefault();*/}
            {/*  signOut();*/}
            {/*}}>*/}
            {/*  Logout*/}
            {/*</a>*/}
            <div className="ml6">
              <BtnTableGlobal
                icon={ExitToApp}
                text="Exit"
                onClick={signOut}
                data-testid="btnLogout"
              />
            </div>
          </div>
        )}
        {/*{*/}
        {/*  account ? (*/}
        {/*    <Menu*/}
        {/*      transformOriginTop="right top"*/}
        {/*      transformOriginBottom="right bottom"*/}
        {/*      items={[{*/}
        {/*        name: <span className="cEE4F4F">Logout</span>,*/}
        {/*        onClick: signOut*/}
        {/*      }]}*/}
        {/*    >*/}
        {/*      <div className="sq60 r50% crPointer">*/}
        {/*        <img className="sq r50%" src={require("../assets/face.jpg")} alt="avatar"/>*/}
        {/*      </div>*/}
        {/*    </Menu>*/}
        {/*  ) : null*/}
        {/*}*/}
      </div>
    )
  }
}, {
  account: account$
})
